var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50554 6.22129C3.3654 6.30352 3.24598 6.41679 3.15647 6.55239C3.06696 6.68799 3.00975 6.84232 2.98922 7.0035C2.9687 7.16467 2.98542 7.32841 3.03808 7.48212C3.09075 7.63583 3.17797 7.77541 3.29304 7.89013L9.11058 13.7077C9.2253 13.8227 9.36488 13.91 9.51858 13.9626C9.67229 14.0153 9.83603 14.032 9.99721 14.0115C10.1584 13.991 10.3127 13.9337 10.4483 13.8442C10.5839 13.7547 10.6972 13.6353 10.7794 13.4952C11.4685 12.3097 11.674 10.9042 11.3532 9.571L15.9779 6.62788C16.1121 6.54249 16.2255 6.42805 16.3096 6.293C16.3937 6.15795 16.4464 6.00573 16.4638 5.84759C16.4812 5.68944 16.4629 5.52941 16.4101 5.3793C16.3574 5.22919 16.2717 5.09283 16.1592 4.98029L12.0204 0.841502C11.9079 0.729006 11.7716 0.643205 11.6215 0.590433C11.4714 0.537661 11.3114 0.519265 11.1533 0.536602C10.9952 0.553939 10.8429 0.606566 10.7078 0.690601C10.5728 0.774635 10.4583 0.887931 10.3728 1.02213L7.4297 5.64754C6.09655 5.32672 4.69103 5.53222 3.50554 6.22129V6.22129Z",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20004 10.7993L0.53125 16.4681",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.f785cf17.svg";
export { ForwardRef as ReactComponent };